import { jwtDecode } from '~/modules/common/utils/stringUtils';

export default ({ app, req, res, route, redirect }) => {
  // return if authenticated
  const authenticated = isAuthenticated(app.$cookies.get('o-auth-token'));
  if (authenticated || (req && req.url && req.url.includes('ia=true'))) return true;

  // get auth tokens from headers
  const authToken = req?.headers['o-a-auth-token'];
  const refreshToken = req?.headers['o-a-refresh-token'];
  if (!authToken || !refreshToken) return false;

  // set cookies
  app.$cookies.set('o-auth-token', authToken, {
    path: '/',
    maxAge: 60 * 60 * 24 * 30, // 30 gün
  });
  app.$cookies.set('o-refresh-token', refreshToken, {
    path: '/',
    maxAge: 60 * 60 * 24 * 60, // 60 gün
  });

  // redirect to the same page with ia flag
  const url = new URL(route.fullPath, `http://${req.headers.host}`);
  url.searchParams.set('ia', 'true');
  return redirect(url.toString());
};

// check authenticated status
const isAuthenticated = (token) => {
  if (!token) return false;
  // Check if the token is expired
  const decoded = jwtDecode(token);
  if (!decoded) return false;
  if (decoded.exp < Date.now() / 1000) {
    return false;
  }
  return true;
};
